import React, { Component } from "react";
import { connect } from "react-redux";
import InfoModal from "./InfoModal";
import { closePaymentIssueModal } from "../../actions/generalActions";
export class PaymentIssueModal extends Component {
  bodyContent(errMessage) {
    return (
      <div style={{ width: "100%" }}>
        <p>{errMessage}</p>
        <p>Click on the button below to manage your subscription</p>
        <button
          className="btn btn-primary"
          // onClick = {}
          style={{ margin: "auto" }}
        >
          Manage Subscription
        </button>
      </div>
    );
  }

  render() {
    return (
      <InfoModal
        modalShow={this.props.modalShow}
        onHide={this.props.closePaymentIssueModal}
        heading={"There is an issue with your subscription payment"}
        bodyHTML={true}
        bodyHTMLFunction={() => this.bodyContent(this.props.errMessage)}
        showFooter={false}
      />
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  closePaymentIssueModal,
})(PaymentIssueModal);
